  <div class="row">
    <div class="col-md-4 col-sm-12">
      <app-social-networks></app-social-networks>
    </div>
    <div class="col-md-8 col-sm-12">
      <app-personal-projects></app-personal-projects>
    </div>
  </div>
